module.exports = __webpack_public_path__ + "static/img/panel-window_256.6345d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/panel-window_256.png
// module id = VK6w
// module chunks = 0